import {
  ArrowDown,
  ArrowRight,
  BookOpen,
  Briefcase,
  Calendar,
  CheckCircle,
  CheckSquare,
  Clock,
  FileText,
  Gift,
  GraduationCap,
  Heart,
  Layout,
  Lightbulb,
  Mail,
  MessageCircle,
  Mic,
  PlayCircle,
  Rocket,
  ShoppingBag,
  Sparkles,
  Target,
  User,
  Users,
  Video,
  Wand2,
  Youtube,
} from "lucide-react";

export const iconRegistry = {
  ArrowDown,
  ArrowRight,
  BookOpen,
  Briefcase,
  Calendar,
  CheckCircle,
  CheckSquare,
  Clock,
  FileText,
  Gift,
  GraduationCap,
  Heart,
  Layout,
  Lightbulb,
  Mail,
  MessageCircle,
  Mic,
  PlayCircle,
  Rocket,
  ShoppingBag,
  Sparkles,
  Target,
  User,
  Users,
  Video,
  Wand2,
  Youtube,
};

export const iconNames = Object.freeze(Object.keys(iconRegistry));
